import { createFileRoute } from '@tanstack/react-router'
import EditionInside from 'Edition/components/sections/Layout/EditionInside'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/layout-inside')({
    component: EditionInside,
})
